import React from 'react';
import ArrowLeft from '../Icons/ArrowLeft';
import classes from './Button.css'

const button = (props) => {
  let buttonClass = [classes.Button, classes.ButtonPositive]
  
  if (props.negative) {
    buttonClass = [classes.Button, classes.ButtonNegative]
  } 
  if (props.disabledButton) {
    buttonClass.push(classes.ButtonDisabled);
  }
  if (props.isBackButton) {
    buttonClass.push(classes.ButtonBack);
  }

  return (
    <button
      className={buttonClass.join(' ')}
      onClick={props.clicked}
      disabled={props.disabledButton}>{props.isBackButton? <ArrowLeft fill="white" /> : props.btnLabel}</button>
  );
};

export default button;


// WEBPACK FOOTER //
// ./src/components/UI/Button/Button.js